<template>
  <div>
    <div class="ui top attached tabular menu" ref="branches_tabs">
      <a
        class="item"
        :data-tab="'branch_' + index"
        v-for="(branch, index) in conf.branch_based.branches"
        :key="index"
        >{{ branch.branch.name }}</a
      >
    </div>
    <div
      class="ui bottom attached tab segment"
      :data-tab="'branch_' + index"
      v-for="(branch, index) in conf.branch_based.branches"
      :key="index"
    >
      <div class="eight wide column field">
        <label for>{{ $t("movement to charge") }}</label>
        <div
          class="ui selection dropdown"
          ref="movement_dropdown"
          :data-branch="branch.branch.uuid"
        >
          <input type="hidden" name="ddwn" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="ui relaxed list">
        <div class="item" v-for="(mv, idx) in branch.movements" :key="idx">
          <i class="large green check middle aligned icon"></i>
          <div class="content">
            <div class="ui grid">
              <div class="two wide column">
                <div class="field">
                  <label for v-if="idx == 0">{{ $t("quantity") }}</label>
                  <input
                    type="text"
                    v-model="
                      conf.branch_based.branches[index].movements[idx].quantity
                    "
                  />
                </div>
              </div>
              <div class="eight wide column">
                <div class="field">
                  <label for v-if="idx == 0">{{ $t("movement type") }}</label>
                  <h4 class="ui header">{{ mv.movement.name }}</h4>
                </div>
              </div>
              <div class="three wide column">
                <div class="field">
                  <label for v-if="idx == 0">{{ $t("amount") }}</label>
                  <input
                    type="text"
                    v-model="
                      conf.branch_based.branches[index].movements[idx].amount
                    "
                  />
                </div>
              </div>
              <div class="three wide column">
                <div class="field">
                  <label for v-if="idx == 0">{{ $t("options") }}</label>
                  <div
                    class="ui basic icon button"
                    :data-tooltip="$t('delete')"
                    @click="remove_mv(branch, index, mv, idx)"
                  >
                    <i class="red trash icon"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import { local_api, stringify } from "@/utils";

export default {
  name: "BranchBased",
  components: {},
  computed: {},
  data() {
    return {
      conf: {
        rule: "",
        branch_based: {
          branches: [],
        },
      },
      branches: [],
    };
  },
  methods: {
    remove_mv(branch, branchIndex, movement, index) {
      this.conf.branch_based.branches[branchIndex].movements.splice(index, 1);
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/student_configuration/do-get-configuration")
      .then((conf) => {
        vm.branches = conf.std_branches;
        vm.branches.map((b) => {
          let trgt = vm.conf.branch_based.branches.find(
            (br) => br.branch.uuid == b.uuid,
          );
          if (!trgt)
            vm.conf.branch_based.branches.push({ branch: b, movements: [] });
        });
        setTimeout(() => {
          window
            .jQuery(vm.$refs.branches_tabs)
            .find(".item")
            .tab();
        }, 500);
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    local_api(vm, "post", "/account_movement_type/do-get-list", {})
      .then((movementTypes) => {
        let vls = movementTypes.map((t) => {
          return { name: t.name, value: t.uuid };
        });
        let mmvntTypes = movementTypes.map((m) => {
          m.setup = JSON.parse(m.setup);
          return m;
        });
        console.log(vls);
        window
          .jQuery(vm.$refs.movement_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              let trgtMovement = mmvntTypes.find((m) => m.uuid == value);
              let amount =
                trgtMovement && trgtMovement.setup
                  ? trgtMovement.setup.default_amount || 0
                  : 0;
              let branchUuid = window.jQuery(this).data("branch");
              let trgtSourceBranch = vm.branches.find(
                (b) => b.uuid == branchUuid,
              );

              let trgtBranch = vm.conf.branch_based.branches.find(
                (b) => b.branch.uuid == trgtSourceBranch.uuid,
              );

              if (!trgtBranch) {
                vm.conf.branch_based.branches.push({
                  branch: trgtSourceBranch,
                  movements: [
                    { movement: trgtMovement, quantity: 1, amount: amount },
                  ],
                });
              } else {
                trgtBranch.movements.push({
                  movement: trgtMovement,
                  quantity: 1,
                  amount: amount,
                });
              }
            },
          });
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    window.jQuery(vm.$refs.rule_dropdown).dropdown({
      onChange(value) {
        vm.conf.rule = value;
      },
    });
  },
  watch: {},
  updated: function() {},
};
</script>
